<template>
  <router-view />
</template>

<script>
export default {
  name: 'Trashed'
}
</script>

<style scoped>

</style>
